import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchBoxService {
  searchBoxStatus$ = new BehaviorSubject(false);

  constructor() {}

  toggleStatus(status: boolean) {
    this.searchBoxStatus$.next(status);
  }

  getStatus() {
    return this.searchBoxStatus$.asObservable();
  }
}
